
import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';



import IntroPopup from './IntroPopup.js';


import SlideUp from './SlideUp';


export default class Simple extends React.Component {
  render() {


    


    return (


        <div>

                               

                                <SlideUp></SlideUp>


              </div>

        )

    }

}
